import useUrlState from '@ahooksjs/use-url-state'
import { PlusOutlined, SearchOutlined, TeamOutlined } from '@ant-design/icons'
import { useDebounce } from 'ahooks'
import { Button, Input, Tabs } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GroupAvatar } from '@/components'
import { useGetGroupCategoriesQuery } from '@/generated/graphql'
import { GroupCreateEdit } from '@/modules/group/group-create-edit'

import { FeaturedGroup } from '../featured-groups/featured-group.component'
import s from './all-groups.module.less'
import { CategoricalGroup } from './categorical-group.component'

const { TabPane } = Tabs

interface State {
  categoryId: string | 'all'
}

const AllGroups = 'all'

export const DiscoverAllGroups: React.FC<{ type: 'all' | 'viewer' }> = ({ type }) => {
  const isViewerGroups = type === 'viewer'
  const { t } = useTranslation()
  const [search, setSearch] = React.useState<string>('')
  const debouncedSearch = useDebounce(search, { wait: 500 })

  const [state, setState] = useUrlState<State>({
    categoryId: AllGroups,
  })

  const { data } = useGetGroupCategoriesQuery()

  const groupCategories = data ? data.groupCategories : []

  const searchBar = (
    <Input
      suffix={<SearchOutlined />}
      placeholder={t('group.search')}
      allowClear
      style={{ width: 200, marginRight: 16 }}
      onChange={(e) => setSearch(e.target.value)}
      value={search}
    />
  )

  const addButton = !isViewerGroups && (
    <GroupCreateEdit>
      <Button type={'text'} shape={'circle'}>
        <PlusOutlined style={{ color: '#48bbb5', fontSize: 24 }} />
      </Button>
    </GroupCreateEdit>
  )

  const extra = !isViewerGroups && (
    <div className={s.headerExtra}>
      <div className={s.add}>{addButton}</div>
      {searchBar}
    </div>
  )

  const header = (
    <div className={s.header}>
      <Tabs
        tabBarGutter={20}
        animated={false}
        activeKey={search ? AllGroups : String(state.categoryId)}
        onChange={(categoryId) => {
          setState({ categoryId })
          setSearch('')
        }}
        tabBarExtraContent={extra}
      >
        <TabPane
          tab={
            <span>
              <span style={{ marginRight: -8 }}>
                <TeamOutlined style={{ color: '#48bbb5' }} />
              </span>
              {t('groups.allGroups')}
            </span>
          }
          key={AllGroups}
        />
        {groupCategories.map((groupCategory) => (
          <TabPane
            tab={
              <span>
                <span style={{ marginRight: -8 }}>
                  <GroupAvatar groupCatId={groupCategory.groupCategoryId} />
                </span>
                {t(`groups.category.${groupCategory.groupCategoryId}`)}
              </span>
            }
            key={groupCategory.groupCategoryId}
          />
        ))}
      </Tabs>
    </div>
  )

  return (
    <>
      {header}
      {!isViewerGroups && (
        <FeaturedGroup categoryId={state.categoryId === AllGroups ? null : Number(state.categoryId)} />
      )}
      <CategoricalGroup
        type={type}
        search={debouncedSearch}
        categoryId={state.categoryId === AllGroups ? null : Number(state.categoryId)}
      />
    </>
  )
}
